import {Component, Input, OnInit} from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {Partner} from '../app-models/models';
import {AuthenticationService} from '../authentication-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ManagePartnerService} from '../manage-partner.service';
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-manage-partner',
  templateUrl: './manage-partner.component.html',
  styleUrls: ['./manage-partner.component.css'],
  providers: [ManagePartnerService]
})
export class ManagePartnerComponent implements OnInit {

  private id: string;
  private compObj: Partner;
  private actionMessage: string;
  private actionStatus = true;
  private isAdmin = false;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ManagePartnerService, private route: ActivatedRoute) {
    this.isAdmin = IsAdmin.call(this);
  }

  ngOnInit() {

    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      ResetAuthToken.call(this);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
    this.route.queryParams
      .subscribe(params => {
        this.id = params['id'];
      });
    this.componentService.getData(this.id).then(this.mainSuccess.bind(this))
      .catch(this.mainFail.bind(this));
  }

  mainSuccess(result) {
    this.compObj = result;
  }

  mainFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    }
  }

  onSubmit() {
    this.actionMessage = null;
    this.componentService.editData(this.compObj).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      const jsonError = JSON.parse(e._body);
      if (!isNullOrUndefined(jsonError.sub_status)) {
        this.actionMessage = jsonError.message;
      } else {
        this.actionMessage = 'Save Failed!';
      }
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    if (this.compObj.skyswitch_reseller != null) {
      this.actionMessage = 'Success!  Click Create->Order to place an order for a domain.';
    } else {
      this.actionMessage = 'Success!';
    }
  }

  onDelete() {
    this.actionMessage = null;
    this.componentService.deleteItem(this.compObj.id).then(this.deleteSuccess.bind(this))
      .catch(this.deleteFail.bind(this));
  }

  deleteFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Delete Failed!';
    }
  }

  deleteSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/manage-partner/manage-partner.component.ts